export default __webpack_public_path__ + "static/media/first_two_page_birth_certificate.f042111a.jpg";